<template>
  <div class="diy-attribute">
    <el-input
      v-if="type === 'input'"
      v-model="curValue"
      @input="update">
    </el-input>
    <el-select
      filterable
      v-if="type === 'select'"
      v-model="curValue"
      @change="update">
      <el-option
        v-for="(item,index) in curOption"
        :key="index"
        :label="item"
        :value="item">    
      </el-option>
    </el-select>
    <el-radio-group
      v-if="type ==='radio'"
      v-model="curValue"
      @change="update">
      <el-radio
        v-for="(item,index) in curOption"
        :key="index"
        :label="item">
        {{ item }}
      </el-radio>
    </el-radio-group>
    <el-select
      filterable
      v-if="type === 'multipleSelect'"
      @change="update"
      v-model="curValue"
      multiple
      placeholder="请选择">
      <el-option
        v-for="item in curOption"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
    <el-input
      v-if="type === 'number'"
      class="diy-input-number"
      @blur="update"
      type="number"
      v-model="curValue"
      placeholder="请输入数字">
    </el-input>
    <el-select
      filterable
      remote
      :remote-method="remoteMethod"
      :multiple-limit="10"
      @click.native="getMyOptions(attr)"
      v-if="type === 'model'"
      @change="update"
      v-model="curValue"
      multiple
      placeholder="请选择">
      <el-option
        v-for="item in curOption === undefined ? [] : curOption"
        :key="'model' + item.id"
        :label="item.value"
        :value="item.id">
      </el-option>
    </el-select>
    <el-checkbox-group
      v-if="type === 'checkBox'"
      v-model="curValue"
      @change="update">
      <el-checkbox
        v-for="(item, index) in curOption"
        :key="index"
        :label="item">{{ item }}
      </el-checkbox>
    </el-checkbox-group>
    <el-date-picker
      @change="update"
      v-if="type === 'datePicker'"
      v-model="curValue"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
    <el-date-picker
      @change="update"
      v-if="type === 'dateTimePicker'"
      v-model="curValue"
      type="datetime"
      value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期">
    </el-date-picker>
    <el-cascader
      @change="update"
      v-if="type === 'addressPicker'"
      :options="regionData"
      v-model="curValue">
    </el-cascader>
    <div v-if="type === 'img'">
      <div v-if="dialogImageUrl.length > 0" style="display: inline-block;">
        <div v-for="(item, index) in dialogImageUrl" :key="index" class="terminalDiv terminalImg"  :style="index === 4? 'margin-right:0': ''">
          <img :src="item" class="terminalImg" :style="index === 4? 'margin-right:0': ''">
          <div class="hoverImg" @click="delectImgFun(index)">
            <span>删除</span>
          </div>
        </div>
      </div>
      <el-upload
        style="display:inline-block"
        name="file_upload"
        :action="uploadURL"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
        :show-file-list="false">
        <img v-if="dialogImageUrl.length < 5" src="../../assets/images/terminalImg.png" class="terminalImg" style="margin-right:0;">
      </el-upload>
    </div>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import { getMyAboutModelList } from '@/api/set.js'
export default {
  name: 'field',
  props: ['type', 'option', 'value', 'attr', 'dialogImageUrl'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      regionData: regionData,
      curValue: this.value,
      curOption: this.option
    }
  },
  watch: {
    value:{
      handler: function (val) {
        console.log('val', val)
        if (this.type === 'address') {
          this.curValue[0] = TextToCode[val[0]].code
          this.curValue[1] = TextToCode[val[0]][val[1]].code
          this.curValue[2] = TextToCode[val[0]][val[1]][val[2]].code
        } else {
          this.curValue = val
        }
      },
      deeep: true
    } 
  },
  /*
  computed: {
    val: {
      // getter
      get: function () {
        return this.value
      },
      // setter
      set: function (newValue) {
        this.curValue = newValue
      }
    }
  },
  */
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过 1MB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.dialogImageUrl.push(res.data.path)
      this.$emit('dialogImage', this.dialogImageUrl)
    },
    delectImgFun (index) {
      this.dialogImageUrl.splice(index, 1)
    },
    // 远程搜索
    remoteMethod(query) {
      if (query !== '') {
        this.attrQuery = query
        this.loading = true
        let modelId = JSON.parse(this.attrValue.options)[0].modelId
        let identity = JSON.parse(this.attrValue.options)[2].identity
        getMyAboutModelList(modelId, identity, query).then((res) => {
          if (res.data.code == 200) {
            this.loading = false
            this.curOption = res.data.result.list
          }
        })
      } else {
        this.curOption = []
      }
    },
    // 模型加载自己的对应的选项
    getMyOptions(attr) {
      console.log('attr', attr)
      let modelId = JSON.parse(attr.options)[0].modelId
      let identity = JSON.parse(attr.options)[2].identity
      // getMyAboutModelList(modelId, identity).then((res) => {
      //   if (res.data.code == 200) {
      //     this.curOption = res.data.result.list
      //   }
      // })
    },
    update() {
      let value = []
      if (this.type === 'address') {
        value[0] = CodeToText[val[0]]
        value[1] = CodeToText[val[1]]
        value[2] = CodeToText[val[2]]
      } else {
        value = this.curValue
      }
      this.$emit('change', value)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.diy-attribute{text-align: left}
.terminalImg{
  width: 60px;
  height: 60px;
  margin-right: 10px;
}
.terminalDiv{
  position: relative;
  display: inline-block;
  text-align: center;
}
.terminalDiv:hover .hoverImg{
  display: block;
}
.hoverImg{
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  width: 100%;
  height: 100%;
  color: #fff;
  line-height: 90px;
}
</style>
